import React from 'react';
import { ArrowLeft, Trophy, Crown } from 'lucide-react';
import { LeaderboardList } from '../leaderboard/LeaderboardList';

interface HallOfChampionsProps {
  onBack: () => void;
}

export function HallOfChampions({ onBack }: HallOfChampionsProps) {
  return (
    <div className="min-h-screen bg-amber-900 text-amber-100 p-8 bg-[url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&q=80')] bg-cover bg-center bg-blend-overlay">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Kingdom
        </button>

        <div className="text-center mb-12">
          <div className="flex justify-center gap-3 mb-4">
            <Trophy className="w-12 h-12 text-yellow-500" />
            <Crown className="w-12 h-12 text-yellow-500" />
          </div>
          <h1 className="text-4xl font-bold font-serif mb-4 bg-gradient-to-r from-yellow-500 to-amber-500 text-transparent bg-clip-text">
            Hall of Champions
          </h1>
          <p className="text-xl text-amber-200 font-serif">
            The greatest warriors of the realm
          </p>
        </div>

        <LeaderboardList />
      </div>
    </div>
  );
}